<!--Instructions-->
<div class="ItemBorder">
	<h4 style="text-align: center">Instructions:</h4>

	<div class="AlignCenter">
		<ul>
			<li>
				<p class="InstructionText">Search for staff to email</p>
			</li>
			<li>
				<p class="InstructionText">Select staff from 1st table</p>
			</li>
			<li>
				<p class="InstructionText">Fill in staff emails in 2nd table</p>
			</li>
			<li>
				<p class="InstructionText">
					Press the email button and the staff will receive a email with a QR code and link to register for the Digital ID app
				</p>
			</li>
		</ul>
	</div>
</div>

<!--Search Options-->
<div class="SearchOptionBorder TopMargin">
	<h4>Search Options:</h4>

	<div class="SearchOptionDiv">
		<label>School:</label>
		<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText"> </caass-schoolselector>

		<label>Staff Type:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstPersonType"
			[(ngModel)]="SelectedPersonType"
			optionLabel="PersonTypeDesc"
			[filter]="true"
			filterBy="PersonTypeDesc"
			[showClear]="false"
			placeholder="Select a Staff Type"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedPersonType">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedPersonType.PersonTypeDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-PersonTypeItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ PersonTypeItem.PersonTypeDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Teaches Course:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstCourse"
			[(ngModel)]="SelectedCourse"
			optionLabel="CourseDesc"
			[filter]="true"
			filterBy="CourseDesc"
			[showClear]="false"
			placeholder="Select a Course"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedCourse">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedCourse.CourseDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-CourseItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ CourseItem.CourseDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Active:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ActiveOptionID" [(ngModel)]="ActiveOptionID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>

		<label>Already Printed:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="AlreadyPrintedID" [(ngModel)]="AlreadyPrintedID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAlreadyPrinted" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onSearch()">Search</button>
	</div>
</div>

<!--Select Table-->
<div class="TopMarinExtra">
	<p-accordion>
		<p-accordionTab
			header="Add Staff to List {{ SelectStaffExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="SelectStaffExpand"
		>
			<div>
				<caass-staff-manual-staff-table [loading]="loading" [lstPerson]="lstPerson" (AddToList)="onAddToList($event)"> </caass-staff-manual-staff-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--To Email Table-->
<div class="TopMarinExtra">
	<p-accordion>
		<p-accordionTab header="Staff to Email {{ EmailStaffExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}" [(selected)]="EmailStaffExpand">
			<div>
				<caass-staff-manual-email-table
					[lstPerson]="lstToEmail"
					[Processing]="Processing"
					(SendEmail)="onSendEmail($event)"
					(RemovePerson)="onRemovePerson($event)"
				>
				</caass-staff-manual-email-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>
